import http from '../../../utils/http';
import security from '../../../utils/security';
import {
    INVOICE_LIST_ERROR,
    INVOICE_LIST_LOADING,
    INVOICE_LIST_ORDER,
    INVOICE_LIST_PAGE,
    INVOICE_LIST_PAGINATION,
    INVOICE_LIST_RESET,
    INVOICE_LIST_SUCCESS
} from './mutation-types';

const state = {
  loading: false,
  error: '',
  items: [],
  pagination: [],
  order: {
    field: 'number',
    direction: 'asc'
  },
  filter: {
    number: '',
    customer: ''
  },
  currentPage: 1
};

function error(error) {
  return {type: INVOICE_LIST_ERROR, error};
}

function loading(loading) {
  return {type: INVOICE_LIST_LOADING, loading};
}

function success(items) {
  return {type: INVOICE_LIST_SUCCESS, items};
}

function pagination(items) {
  return { type: INVOICE_LIST_PAGINATION, items};
}

const getters = {
  error: state => state.error,
  items: state => state.items,
  loading: state => state.loading,
  pagination: state => state.pagination,
  order: state => state.order,
  filter: state => state.filter,
  currentPage: state => state.currentPage
};

const actions = {

    markAsPaid({commit, state}, payload) {
        commit(loading(true));
        commit(error(null));
        payload.paid = true;

        return http.fetch(payload['@id'], {
                method: 'PUT',
                headers: new Headers({'Content-Type': 'application/ld+json'}),
                body: JSON.stringify(
                    {
                        id: payload.id,
                        fullNumber: payload.fullNumber,
                        customer: payload.customer,
                        customerData: {
                            name: payload.customerData.name,
                            nip: payload.customerData.nip,
                            regon: payload.customerData.regon,
                            customerAddress: {
                                city: payload.customerData.customerAddress.city,
                                number: payload.customerData.customerAddress.number,
                                postalCode: payload.customerData.customerAddress.postalCode,
                                street: payload.customerData.customerAddress.street,
                                country: payload.customerData.customerAddress.country
                            }
                        },
                        items: payload.items,
                        correctedInvoice: payload.correctedInvoice,
                        correctedInvoiceItems: payload.correctedInvoiceItems,
                        correction: payload.correction,
                        paymentDate: payload.paymentDate,
                        endDate: payload.endDate,
                        createDate: payload.createDate,
                        comments: payload.comments,
                        currency: payload.currency['@id'],
                        paymentType: payload.paymentType['@id'],
                        amount: payload.amount,
                        paid: payload.paid,
                    }
                ),
            }
        )
        .then(data => {
            commit(loading(false));
        })
        .catch(e => {
            commit(loading(false));
            if (security.handleAuthorizationError(e)) {
                return;
            }
            commit(error(e.message));
        });

    },

    getItems({ commit, state }, page = '/invoices') {
      commit(loading(true));
      commit(error(null));

      return http.fetch(page + '?' + http.buildQueryParams(state.currentPage, state.order, state.filter))
        .then(response => response.json())
        .then(data => {
          commit(loading(false));
          commit(success(data['hydra:member']));
          commit(pagination(data['hydra:pagination']));
        })
        .catch(e => {
          commit(loading(false));
          if(security.handleAuthorizationError(e)){
            return;
          }
          commit(error(e.message));
        });
    },
    order: function(context, column) {
      context.commit(INVOICE_LIST_ORDER, column);
      context.dispatch('getItems');
    },
    changePage: function(context, page) {
      context.commit(INVOICE_LIST_PAGE, page);
      context.dispatch('getItems');
    }
};

const mutations = {
    [INVOICE_LIST_ERROR] (state, payload) {
      state.error = payload.error;
    },
    [INVOICE_LIST_LOADING] (state, payload) {
      state.loading = payload.loading;
    },
    [INVOICE_LIST_PAGINATION] (state, payload) {
      state.pagination = payload.items;
    },
    [INVOICE_LIST_SUCCESS] (state, payload) {
      state.items = payload.items;
    },
    [INVOICE_LIST_RESET] (state) {
      state.items = [];
      state.currentPage = 1;
    },
    [INVOICE_LIST_ORDER] (state, column) {
      if (state.order.field == column && state.order.direction !== 'desc') {
        state.order.direction = 'desc';
      }
      else if (state.order.field == column && state.order.direction == 'desc') {
        state.order.field = '';
      }
      else {
        state.order.direction = 'asc';
        state.order.field = column;
      }
    },
    [INVOICE_LIST_PAGE] (state, page) {
       state.currentPage = page;
    }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/invoice/list.js